export default __webpack_public_path__ + "static/media/chase.8571735f.svg";